import _typeof from "@babel/runtime/helpers/typeof";
import _inherits from "@babel/runtime/helpers/inherits";
import _setPrototypeOf from "@babel/runtime/helpers/setPrototypeOf";
function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(e, r) { return new BabelRegExp(e, void 0, r); }; var e = RegExp.prototype, r = new WeakMap(); function BabelRegExp(e, t, p) { var o = RegExp(e, t); return r.set(o, p || r.get(e)), _setPrototypeOf(o, BabelRegExp.prototype); } function buildGroups(e, t) { var p = r.get(t); return Object.keys(p).reduce(function (r, t) { var o = p[t]; if ("number" == typeof o) r[t] = e[o];else { for (var i = 0; void 0 === e[o[i]] && i + 1 < o.length;) i++; r[t] = e[o[i]]; } return r; }, Object.create(null)); } return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (r) { var t = e.exec.call(this, r); if (t) { t.groups = buildGroups(t, this); var p = t.indices; p && (p.groups = buildGroups(p, this)); } return t; }, BabelRegExp.prototype[Symbol.replace] = function (t, p) { if ("string" == typeof p) { var o = r.get(this); return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)>/g, function (e, r) { var t = o[r]; return "$" + (Array.isArray(t) ? t.join("$") : t); })); } if ("function" == typeof p) { var i = this; return e[Symbol.replace].call(this, t, function () { var e = arguments; return "object" != _typeof(e[e.length - 1]) && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e); }); } return e[Symbol.replace].call(this, t, p); }, _wrapRegExp.apply(this, arguments); }
import { createToken } from '../utils/create-token';

// Some nodes will be inline but it's content will be empty.
// That's why, don't remove paragraphs wrapping it.
// For example, inlineExtension is inline node, so there should be no content inside it.
//  So it's custom element is represented by <custom data-type="inlineExtension" ... />
var emptyInlineCustomNodes = ['inlineExtension'];
export default function (md, idMap, htmlConversionCounts) {
  md.core.ruler.after('inline', 'custom-block', function (state) {
    state.tokens = state.tokens.reduce(function (acc, token, index) {
      var _match$groups;
      var match = token.content.match(
      /*#__PURE__*/
      /**
       * Matches the following:
       * <custom data-type="smartlink" data-id="123" />
       * <custom data-type="smartlink" />
       */
      _wrapRegExp(/<custom\s+data\x2Dtype="(.*?)"\s*(data\x2Did="(.*?)"\s*)?\/>/, {
        dataType: 1,
        dataId: 3
      }));
      var dataType = match === null || match === void 0 || (_match$groups = match.groups) === null || _match$groups === void 0 ? void 0 : _match$groups.dataType;
      if (match && dataType && !emptyInlineCustomNodes.includes(dataType)) {
        var _match$groups2;
        var dataId = (_match$groups2 = match.groups) === null || _match$groups2 === void 0 ? void 0 : _match$groups2.dataId;
        if (dataType) {
          htmlConversionCounts.htmlConvertedToNodes++;
          var customElementToken = createToken(state, dataType);
          if (dataId && idMap[dataId]) {
            // @ts-ignore
            customElementToken.pmAttrs = idMap[dataId].attributes;
          }
          /**
           * When the custom tag goes through the tokenizer it is transformed into this structure:
           * paragraph_open
           * inline
           * paragraph_close
           *
           * so the following section removes the wrapping paragraph tokens
           */
          acc.splice(acc.length - 1, 1);
          state.tokens.splice(index + 1, 1);

          // We then push replace the inline token with our custom token
          acc.push(customElementToken);
        } else {
          htmlConversionCounts.htmlConvertedToFallbackNodes++;
          acc.push(token);
        }
      } else {
        acc.push(token);
      }
      return acc;
    }, []);
  });
}